export function extractContentFromTag(html: string, tag = "p"): string | null {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");

  const pTag = doc.querySelector(tag);

  return pTag ? pTag.textContent : "";
}
